'use strict';

wbApp.controller('MyActivitiesCtrl', ['$scope', '$modal', '$translate', '$timeout', 'tenantSettingSvc', 'activitySvc', 'activityAttendanceSvc', 'activityReconciliationSvc',
function ($scope, $modal, $translate, $timeout, tenantSettingSvc, activitySvc, activityAttendanceSvc, activityReconciliationSvc) {

    $scope.tabs = [
        {
            title: 'TXT_TAB_ACTIVITY_SELECTION',
            template: 'my-activities/activities-tab.html'
        },
        {
            title: 'TXT_TAB_ATTENDANCE',
            template: 'my-activities/activity-detail-tab.html'
        }];

    $scope.tabs.activeTab = 0;

    $scope.showGoogleChart = false;

    $scope.tenantSetting = tenantSettingSvc.settings;

    if ($scope.tenantSetting.showExcusesAndAmendsInMyActivities) {
        $scope.tabs.push({
            title: 'TXT_LBL_SUMMARY_OF_CHANGES',
            template: 'my-activities/excuses-and-amends.html'
        });
    }

    $scope.tabs.push({
        title: 'TXT_LBL_PHOTO_ALBUM',
        template: 'my-activities/photo-album.html'
    });

    $scope.activitiesByStudents = activitySvc.getSummary();

    $scope.loadingAttendance = false;

    function extendModel(students) {
        for (var s = 0; s < students.length; s++) {
            var student = students[s];
            for (var a = 0; a < student.activities.length; a++) {
                var activity = student.activities[a];
                activity.isOld = moment(activity.activityEndDate).isBefore(moment());
                student.hasOld |= activity.isOld;
                student.hasNew |= !activity.isOld;
            }
        }
    }

    $scope.activitiesByStudents.$promise.then(function (data) {
        extendModel($scope.activitiesByStudents);
    });

    function resizeGoogleCharts() {
        $timeout(function () {
            $scope.referenceSourceTimeDevelopment.options.chartArea =
                { left: 90, top: 20, right: 30, bottom: 20, width: 800, height: 250 };

            $timeout(function () {
                $scope.referenceSourceTimeDevelopment.options.chartArea =
                    { left: 100, top: 20, right: 30, bottom: 20, width: 900, height: 250 };
            });
        });                
    }

    function loadExusesAndAmendsData(data) {
        $scope.excusesAndAmends = activityAttendanceSvc.getExcusesAndAmendsOnly(data, $scope.selectedActivity.activityID);
        $scope.availableExuses = activityReconciliationSvc.getAvailableExuses($scope.selectedActivity.activityID, $scope.selectedStudent.studentID);
        $scope.availableExuses.$promise.then(function (ex) {
            var rows = [];
            _.forEach(ex.excusesByDate, function (e) {
                rows.push({
                    c: [{ v: e.date }, { v: e.noOfExcuses }]
                });
            });
            $scope.referenceSourceTimeDevelopment.data.rows.length = 0;
            $scope.referenceSourceTimeDevelopment.data.rows.push.apply(
                $scope.referenceSourceTimeDevelopment.data.rows, rows);

            $scope.showGoogleChart = true;
        });
    }

    $scope.photoAlbum = [];
    function loadPhotoAlbum() {
        if (!!$scope.selectedActivity && !!$scope.selectedStudent) {
            activitySvc.getPhotoAlbum($scope.selectedActivity.activityID, $scope.selectedStudent.studentID)
                .$promise.then(function(data) {
                _.forEach(data, function(gallery) {
                    gallery.sourceImages = _.map(gallery.images, 'imageUrl');
                }) 
                $scope.photoAlbum = data;     
            });
        } else {
            $scope.photoAlbum = [];
        }
    }

    $scope.$watch('tabs.activeTab', function (newValue) {
        if ($scope.tenantSetting.showExcusesAndAmendsInMyActivities) {
            if (newValue === 2) {
                resizeGoogleCharts();
            } else if (newValue === 3) {
                loadPhotoAlbum();
            }
        } else if (newValue === 2) {
            loadPhotoAlbum();
        }
    });

    $scope.setSelectedActivity = function (student, activity) {

        $scope.loadingAttendance = true;

        $scope.selectedActivity = activity;
        $scope.selectedStudent = student;
        $scope.selectedActivitySinglePeriodProgramOnly = false;

        $scope.studentAttendanceData = activityAttendanceSvc.getStudentAttendanceDetailAsync(activity.activityID, student.studentID);
        $scope.studentAttendanceData.$promise.then(function (data) {

            var firstAttenandace = _.head(data);
            if (!!firstAttenandace) {
                $scope.selectedActivitySinglePeriodProgramOnly = firstAttenandace.activity.singlePeriodProgramOnly;
            }

            $scope.scheduleMonths = activityAttendanceSvc.filterAndBreakByMonth(data, $scope.selectedActivity.activityID);
            loadExusesAndAmendsData($scope.studentAttendanceData);
            $timeout(function () {
                $scope.loadingAttendance = false;
            });
        });

        $scope.tabs.activeTab = 1;
    }

    $scope.onStudentExpanded = function (student) {
        student.expanded = !student.expanded;
    }

    $scope.setSelectedMonth = function (month) {
        $scope.selectedMonth = month;
        month.expanded = !month.expanded;
    }

    $scope.onExcuseButtonClick = function (schedule, month) {
        $scope.excuseModal = {
            studentName: $scope.selectedStudent.studentFullName,
            fromDate: schedule.startDate,
            toDate: schedule.startDate,
            scheduleOrig: schedule,
            period: {
                am: schedule.firstPeriodAttendanceStatusID == 0,
                pm: schedule.secondPeriodAttendanceStatusID == 0
            },
            notes: schedule.notes || $translate.instant('TXT_VAL_ILLNESS'),
            onSave: function () {
                loadExusesAndAmendsData($scope.studentAttendanceData);
            }
        }


        attendnaceExcuseModalPromise.$promise.then(function () {
            attendnaceExcuseModalPromise.$scope.singlePeriodProgramOnly = $scope.selectedActivitySinglePeriodProgramOnly;
            attendnaceExcuseModalPromise.show();
        });
    }

    $scope.onBookButtonClick = function (schedule, month) {
        $scope.bookModal = {
            studentName: $scope.selectedStudent.studentFullName,
            schedule: schedule.clone(),
            scheduleOrig: schedule,
            period: {
                am: schedule.firstPeriodAttendanceStatusID != 0,
                pm: schedule.secondPeriodAttendanceStatusID != 0
            },
            onSave: function () {
                loadExusesAndAmendsData($scope.studentAttendanceData);
            }
        }

        attendnaceBookModalPromise.$promise.then(function () {
            attendnaceBookModalPromise.$scope.singlePeriodProgramOnly = $scope.selectedActivitySinglePeriodProgramOnly;
            attendnaceBookModalPromise.show();
        });
    }

    var attendnaceExcuseModalPromise = $modal({
        templateUrl: 'my-activities/attendance-excuse-detail.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    var attendnaceBookModalPromise = $modal({
        templateUrl: 'my-activities/attendance-book-detail.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    $scope.referenceSourceTimeDevelopment = {
        type: 'AreaChart',
        data: {
            cols: [{
                id: 'date',
                label: 'Date',
                type: 'date',
                p: {}
            }, {
                id: 'excuses',
                label: $translate.instant('TXT_LBL_AVAILABLE_AMENDS'),
                type: 'number',
                p: {}
            }],
            rows: []
        },
        options: {
            displayExactValues: true,
            isStacked: true,
            chartArea: { left: 100, top: 20, right:0, bottom: 20, width: 900, height: 250 },
            legend: {
                position: 'none'
            },
            backgroundColor: '#F5F5F3',
            vAxis: { ticks: [5, 10, 15, 20] },
            hAxis: {},
            orientation: 'horizontal'
        }
    };

}]);
